import 'react/jsx-runtime';
import { createContext } from 'react';
import '../gen/lang.js';

createContext({});
//# sourceMappingURL=SiteProvider.js.map
